import moment from 'moment'

type Base =
  | 'year'
  | 'years'
  | 'y'
  | 'month'
  | 'months'
  | 'M'
  | 'week'
  | 'weeks'
  | 'w'
  | 'day'
  | 'days'
  | 'd'
  | 'hour'
  | 'hours'
  | 'h'
  | 'minute'
  | 'minutes'
  | 'm'
  | 'second'
  | 'seconds'
  | 's'
  | 'millisecond'
  | 'milliseconds'
  | 'ms'

export const GetListYears = (fromYear: number) => {
  let currentYear = moment().year()
  let arr = []
  for (let i = fromYear; i <= currentYear; i++) {
    let obj = {
      value: i.toString(),
      label: i.toString(),
    }
    arr.push(obj)
  }
  return arr
}

export const GetDateRange = (startDate: string, endDate: string, timeType: Base) => {
  let arrDates = []
  while (moment(startDate, 'YYYY/MM/DD').isSameOrBefore(moment(endDate, 'YYYY/MM/DD'))) {
    if (timeType == 'year') {
      arrDates.push(moment(startDate).format('YYYY'))
    } else if (timeType == 'month') arrDates.push(moment(startDate).format('MM/YYYY'))
    else if (timeType == 'day') arrDates.push(moment(startDate).format('DD/MM/YYYY'))
    startDate = moment(startDate, 'YYYY/MM/DD').add(1, timeType).format('YYYY/MM/DD')
  }
  return arrDates
}
